import {
	type CommandGroupType,
	findCommandById,
	findCommandParent,
} from "@layer/utils/lib/commands";
import { atom } from "jotai";
import { defaultCommands } from "@/lib/constants/commands";

export const commandPageAtom = atom<CommandGroupType[]>(defaultCommands);
export const setCommandPageAtom = atom(
	null,
	(get, set, commandGroup: CommandGroupType) => {
		const currentCommands = get(commandPageAtom);
		if (currentCommands.some((group) => group.id === commandGroup.id)) {
			return;
		}
		set(commandPageAtom, [commandGroup, ...currentCommands]);
	},
);

export const selectCommandPageAtom = atom<string | null>(null);
export const setSelectCommandPageAtom = atom(
	null,
	(_, set, commandId: string | null) => {
		set(selectCommandPageAtom, commandId);
	},
);

/**
 * get the list of active commands based on the current selection, as default it returns all top level commands
 *
 * @param {Getter} - get
 * @returns {CommandGroupType[]} - The active commands or null
 * - If no command is selected, returns the top-level commands
 * - If a command is selected, returns its child commands (commands with parentId matching the selected ID)
 */
export const activeCommandsAtom = atom<CommandGroupType[]>((get) => {
	const commands = get(commandPageAtom);
	const selectedCommandId = get(selectCommandPageAtom);

	if (!selectedCommandId) return commands;

	const command = findCommandById(commands, selectedCommandId);
	return command ? [command] : [];
});

/**
 * get the parent of the currently selected command item or null
 *
 * @param {Getter} - get
 * @returns {CommandItemType | null} - The parent command item or null
 * - If the selected command belongs to a group with a parentId then returns the parent command item.
 * - If no parent exists or no command is selected, returns null.
 * - Used in the Go Back
 */
export const commandParentAtom = atom<CommandGroupType | null>((get) => {
	const commands = get(commandPageAtom);
	const selectedCommandId = get(selectCommandPageAtom);

	if (!selectedCommandId) return null;

	return findCommandParent(commands, selectedCommandId);
});
